import React from 'react';
import SocialNetworks from '../global/SocialNetworks';
import "./Footer.css"

const MAIN_SITE = 'https://www.good-deeds-day.org.il';

export default function Footer() {

  return (
    <footer id="footer">
      <div className="footer-content">
        <div className="contact-info">
          <h4>יום מעשים טובים מטעם עמותת רוח טובה המציעה התנדבות בהתאמה אישית כל השנה</h4>
          <address>שדרות שאול המלך 21, בית שאול, תל אביב-יפו</address>
          <div className="developed-by" aria-label="Arison"></div>
        </div>

        <div className="footer-social" style={{marginTop: '25px'}}>
          <SocialNetworks />
        </div>

        <div className="footer-menu" style={{marginTop: '25px'}}>
          <h2>השתתפו</h2>
          <ul>
            <li><a href={`${MAIN_SITE}/volunteer/`}>התנדבות אישית או עם קבוצה</a></li>
            <li><a href={`${MAIN_SITE}/businesses/`}>חברות ועסקים</a></li>
            <li><a href={`${MAIN_SITE}/project/`}>עמותות וארגונים</a></li>
            <li><a href={`${MAIN_SITE}/local_authorities/`}>רשויות מקומיות</a></li>
          </ul>
        </div>

        <div className="footer-menu" style={{marginTop: '25px'}}>
          <h2>יום מעשים טובים</h2>
          <ul>
            <li><a href={`${MAIN_SITE}/about/`}>אודות</a></li>
            <li><a href={`${MAIN_SITE}/press/`}>אנחנו בתקשורת</a></li>
            <li><a href={`${MAIN_SITE}/contact/`}>צרו קשר</a></li>
            <li><a href={`${MAIN_SITE}/terms/`}>תנאי שימוש</a></li>
            <li><a href={`${MAIN_SITE}/privacy/`}>מדיניות פרטיות</a></li>
            <li><a href={`${MAIN_SITE}/sitemap/`}>מפת אתר</a></li>
            <li><a href={`${MAIN_SITE}/accessibility/`}>הצהרת נגישות</a></li>
            <li><a href="https://www.arisongroup.com/" target="_blank" rel="noopener noreferrer">קבוצת אריסון</a></li>
            <li><a href={`${MAIN_SITE}/gddtshirts/`}>חולצות יום מעשים טובים</a></li>
            <li><a href={`${MAIN_SITE}/faming/`}>FAMING#</a></li>
          </ul>
        </div>
      </div>
    </footer>
  )
}
